const regex = /^(?:an? |the )?(.*)/
export default regex
